import { validateSingleSelection } from '@om/validation';
import { validateEmailAddress } from '@om/validation/src/validators/email-validator';
import {
    validateAlphaNumericStringLenient,
    validateNumericString,
} from '@om/validation/src/validators/string-validator';
import { setBasicDetailsFieldValid } from '../../../actions/allSureMotorClaim/basicDetails';

let prevValidationAction = null;

export const basicDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const trimValue = (value) => (value ? value.trim() : value);
        const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
        let error;

        switch (action.value.fieldType) {
            case 'categoryType':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'privacyNotice':
                error = validateSingleSelection(action.value.value, 'privacy notice');
                break;

            case 'fullName':
                error = validateAlphaNumericStringLenient(action.value.value, {
                    subject: 'full name',
                    min: 3,
                    max: 66,
                });
                break;

            case 'policyNumber':
                error = validateNumericString(action.value.value, {
                    min: 5,
                    max: 10,
                    required: true,
                    subject: 'policy number',
                });
                break;

            case 'mobileNumber':
                error = validateNumericString(removeWhiteSpacesFromValue(action.value.value), {
                    min: 5,
                    max: 16,
                    required: true,
                    subject: 'cellPhone Number',
                });
                break;

            case 'tnc':
                error = validateSingleSelection(action.value.value, 'terms and conditions');
                break;

            case 'consentNotice':
                error = validateSingleSelection(action.value.value, 'consent');
                break;

            case 'email':
                error = validateEmailAddress(trimValue(action.value.value), {
                    min: 7,
                    max: 60,
                    subject: 'Email address',
                    required: true,
                });
                break;

            default:
                return null;
        }
        return setBasicDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
